<template>
    <div class="paper-box">
        <i class="iconfont icon-fanhui1" @click="toBack"></i>
        <route-title></route-title>
        <div class="tip-box" v-if="isAnswer&&remainingTime>0">
            <div class="light"></div>
            <p>距离考试结束还有：{{ secondToHours(remainingTime) }}</p>
        </div>
        <el-button type="primary" v-if="!isAnswer && !isFinish" style="margin-top: 3rem;"
            @click="startAnswer">{{startTime?'继续答题':'开始答题'}}</el-button>
        <div class="top-box">
            <img class="top-img" v-if="isFinish" @click="testPaperReset" src="../../../assets/image/resourceLibrary/replace.png" alt="">
            <div class="top-content">
                <div class="img-box-content" v-if="isFinish">
                    <img class="score-bg" src="../../../assets/image/resourceLibrary/score.png" alt="">
                    <p class="number">{{ computedScore }}</p>
                </div>
                <div class="paper-ev">
                    <div class="paper-name">{{ detail.testPaperName || '暂无' }}</div>
                    <div class="paper-base">
                        <div class="top-item">
                            <p>创建人：</p>
                            <p>{{ detail.createName || '暂无' }}；</p>
                        </div>
                        <div class="top-item">
                            <p>创建院校：</p>
                            <p>{{ detail.institutions || '暂无' }}；</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-content">
                <div class="show-box-ev">
                    <div class="right-item">
                        <p>满分：</p>
                        <p>{{ detail.totalPoints || 0 }}</p>
                    </div>
                    <div class="right-item">
                        <p>总题量：</p>
                        <p>{{ detail.totalQuestionCount || 0 }}</p>
                    </div>
                    <div class="right-item" v-for="(item,index) in detail.questionDetailVOS||{}" :key="index">
                        <p>{{ index }}：</p>
                        <p>{{ item?item.length:0 }}</p>
                    </div>
                </div>
                <div class="operation-box">
                    <i class="iconfont icon-dianzan1" style="font-size: 16px;cursor: pointer; margin-left: 1.5rem;" :class="{dz:detail.likes}" @click="addOptRecord(0)"></i>
                    <p style="font-size: 14px;font-weight: 400;color: #8590B3;margin-left: 0.5rem;">{{ detail.likeCount||0 }}</p>
                    <i class="iconfont icon-shoucang1" style="font-size: 16px;cursor: pointer; margin-left: 1.5rem;" :class="{sc:detail.collect}" @click="addOptRecord(1)"></i>
                    <p style="font-size: 14px;font-weight: 400;color: #8590B3;margin-left: 0.5rem;">{{ detail.collectCount||0 }}</p>
                    <i class="iconfont icon-icon-" style="font-size: 2.2rem;margin-left: 1.5rem;"></i>
                    <p style="font-size: 14px;font-weight: 400;color: #8590B3;margin-left: 0.5rem;">{{ detail.viewCount||0 }}</p>
                </div>
            </div>
        </div>
        <div class="content-box">
            <div class="sub-module-item" v-for="(item, index) in detail.questionDetailVOS && detail.questionDetailVOS"
                :key="index">
                <div class="module-top">
                    <p>{{ numberToChinese(item.orderIndex) + '、' }}</p>
                    <p>{{ index }}</p>
                    <p>{{ `（共${item.length || 0}题，每题${item[0] ? item[0].questionScore : 0}分）` }}</p>
                </div>
                <div class="module-content">
                    <div class="content-item" v-for="(el, k) in item && item" :class="{ 'border-none': k == item.length - 1 }"
                        :key="k">
                        <div class="el-top">
                            <div>{{ k + 1 + '.' }}</div>
                            <div v-html="el.questionStem" class="html-box" :id="el.questionId"></div>
                        </div>
                        <div v-if="index == '填空题'">
                            <div v-for="(e, i) in el.questionOptionVOS" :key="i"
                                style="display: flex;margin-top: 2rem;align-items: center;">
                                <div>{{ alphabet[i] + '：' }}</div>
                                <el-input v-model="e.value" :disabled="Boolean(!isAnswer||isFinish)" style="width: 10rem;"></el-input>
                            </div>
                        </div>
                        <div class="options-box" v-else>
                            <el-radio-group v-model="el.value" :disabled="Boolean(!isAnswer||isFinish)" v-if="['判断题', '单选题'].includes(index)">
                                <el-radio v-for="(e, i) in el.questionOptionVOS" :key="i" :label="e.id">
                                    <div style="display: flex;">
                                        <div>{{ alphabet[i] + '.' }}</div>
                                        <div v-html="e.content" style="white-space: var(--lineWrap);"></div>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                            <el-checkbox-group :disabled="Boolean(!isAnswer||isFinish)" v-model="el.value" v-else-if="index == '多选题'">
                                <el-checkbox v-for="(e, i) in el.questionOptionVOS" :key="i" :label="e.id">
                                    <div style="display: flex;">
                                        <div>{{ alphabet[i] + '.' }}</div>
                                        <div v-html="e.content" style="white-space: var(--lineWrap);"></div>
                                    </div>
                                </el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div class="answer-box" v-if="isFinish">
                            <div class="box-item">
                                <p>您的答案：</p>
                                <div style="display: flex;">
                                    <p v-for="(x, y) in getAnswer(el)" :key="y">{{ x + (y < (getAnswer(el).length - 1) ? '、' : '')
                                            }}</p>
                                </div>
                                <p>得：{{ el.score || 0 }}分</p>
                            </div>
                            <div style="display: flex;margin-top: 1rem;">
                                <p>正确答案：</p>
                                <p style="color: #67c23a;" v-for="(x, y) in getTrueAnswer(el)" :key="y">{{
                                        x + (y < (getTrueAnswer(el).length-1)?'、':'') }}</p>
                            </div>
                            <div class="an-item">
                                <p>题目解析：</p>
                                <p style="white-space: var(--lineWrap);" v-html="el.content"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btn-box" v-if="isAnswer&&!isFinish">
            <el-button size="large" @click="openDialog(0)">暂存题目</el-button>
            <el-button size="large" type="primary" @click="openDialog(1)"
                style="margin-left: 3.5rem;">提交</el-button>
        </div>
        <el-dialog title="提示" :visible.sync="dialogVisible" :close-on-click-modal="false" width="42rem">
            <p class="el-title">提交成功！</p>
            <p class="el-view" @click="viewAnswer">查看答题详情>></p>
        </el-dialog>
        <answer-paper :detail="detail" ref="answer_paper"></answer-paper>
        <save-tip ref="save_tip" :detail="detail" @save_sub="submitTestPaper" :remainingTime="remainingTime"></save-tip>
        <transition name="fade">
            <answer-contral v-if="detail.questionDetailVOS&&isAnswer&&!isFinish" @submit="openDialog" :subData="detail.questionDetailVOS"></answer-contral>
        </transition>
        <answer-sheet :subData="detail.questionDetailVOS" v-if="detail.questionDetailVOS&&!isAnswer&&isFinish"></answer-sheet>
    </div>
</template>

<script>
import { GetTestPaperQuestion, GetUserAnswerRecord, SubmitTestPaper, StartExam, UpdateRemainingTime,TestPaperReset } from '@/api/paper';
import { AddOptRecord } from '@/api/operation';
import { OPERATIONTYPE } from '@/utils/utils';
import AnswerPaper from './AnswerPaper.vue';
import { numberToChinese } from '@/utils/utils';
import { secondToHours } from '@/utils/utils';
import SaveTip from './SaveTip.vue';
import AnswerContral from './AnswerContral.vue';
import AnswerSheet from './AnswerSheet.vue';
export default {
    components: { AnswerPaper, SaveTip, AnswerContral, AnswerSheet },
    data() {
        return {
            paperId: this.$route.query.id,
            testPaperSource: this.$route.query.testPaperSource,
            alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            detail: {},
            recordId:'',
            startTime:null,
            dialogVisible: false,
            /**是否已经开始答题 */
            isAnswer: false,
            /**是否已完成 */
            isFinish: false,
            numberToChinese,
            /**定时器更新考试时间 */
            timer: null,
            /**剩余考试时间 */
            remainingTime: -1,
            /**考试计时器 */
            tTimer: null,
            subData:[],
        }
    },
    computed:{
         /**过滤考生的状态 */
         filterStatus(){
            if(this.isFinish){
              return '已完成';
            }else if(this.isAnswer){
              return '考试中';
            }else{
                return '未开始'
            }
        },
        /**计算总得分 */
        computedScore(){
            var sum=0;
            for(let key in this.detail.questionDetailVOS){
                this.detail.questionDetailVOS[key].forEach(item=>{
                    sum=sum+item.score||0;
                })
            }
            return sum;
        }
    },
    methods: {
        secondToHours,
        /**打开提示弹窗 */
        openDialog(type){
            var dialog=this.$refs.save_tip;
            if(dialog){
                dialog.dialogVisible=true;
                dialog.type=type;
                if(type==0){
                    dialog.title='是否确认暂存题目？';
                }else{
                    dialog.title='是否确认提交题目？';
                }
            }
        },
        /**返回 */
        toBack(){
            this.$router.go(-1);
        },
        /**试卷重置 */
        testPaperReset(){
            this.$confirm('是否确认重置试卷?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    var params={
                        "businessId": this.paperId,
                        "testPaperId": this.paperId,
                        "testPaperSource": "test_paper_lib"
                    };
                    TestPaperReset(params).then(res=>{
                        if(res.code==200){
                            this.getUserAnswerRecord();
                        }
                    })
                  });
        },
        /**新增操作记录 */
        addOptRecord(i) {
            var params = {
                "businessId": this.paperId,
                "businessType": 'test_paper',
                "optType": OPERATIONTYPE[i]
            }
            AddOptRecord(params).then(res=>{
                if(res.code==200){
                    if([0,1].includes(i)){
                        this.updateStatus();
                    }
                }
            });
        },
        /**定时器更新考试时间 */
        updateRemainingTime() {
            if (!this.isAnswer || this.remainingTime == -1||this.isFinish) return;
            this.timer = setInterval(() => {
                if (this.remainingTime <= 0) {
                    this.timer && clearInterval(this.timer);
                    this.remainingTime = 0;
                }
                var params = {
                    "remainingTime": this.remainingTime,
                    "testPaperId": this.paperId
                };
                UpdateRemainingTime(params);
            }, 5000)
        },
        /**考试倒计时 */
        countDown() {
            if(!this.isAnswer||this.remainingTime==-1||this.isFinish)return;
            this.tTimer && clearInterval(this.tTimer);
            this.tTimer = setInterval(() => {
                if (this.remainingTime <= 0) {
                    this.tTimer && clearInterval(this.tTimer);
                    this.submitTestPaper(1);
                }
                this.remainingTime--;
            }, 1000)
        },
        /**通过id过滤出用户选项 */
        getAnswer(data) {
            var answerArr = [];
            if (data.questionType == '填空题') {
                answerArr = data.questionOptionVOS.map(item => {
                    return item.value;
                })
            } else {
                var obj = {};
                data.questionOptionVOS.forEach(item => {
                    obj[item.id] = item;
                })
                if (['单选题'].includes(data.questionType)) {
                    answerArr = [obj[data.value] ? this.alphabet[obj[data.value].orderIndex-1] : ''];
                } else if (data.questionType == '多选题') {
                    data.value.forEach(item => {
                        answerArr.push(this.alphabet[obj[item].orderIndex-1]);
                    })
                } else if (data.questionType == '判断题') {
                    answerArr = [obj[data.value] ? obj[data.value].content : ''];
                }
            }
            return answerArr;
        },
        /**通过id过滤出正确答案选项 */
        getTrueAnswer(data) {
            var answerArr = [];
            var obj = {};
            data.questionOptionVOS.forEach(item => {
                obj[item.id] = item;
            })
            if (['多选题', '单选题'].includes(data.questionType)) {
                data.correctAnswer && data.correctAnswer.forEach(item => {
                    answerArr.push(this.alphabet[obj[item].orderIndex-1])
                })
            } else if (data.questionType == '判断题') {
                data.correctAnswer && data.correctAnswer.forEach(item => {
                    answerArr.push(obj[item].content)
                })
            } else if (data.questionType == '填空题') {
                answerArr = data.correctAnswer;
            }
            return answerArr;
        },
        /**开始考试 */
        startAnswer() {
            this.$confirm('开始考试后将开始计时, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                StartExam({ id: this.paperId }).then(res => {
                if (res.code == 200) {
                    this.isAnswer = true;
                    this.$msg({
                        showClose: true,
                        message: '开始考试成功',
                        type: 'success'
                    });
                    this.countDown();
                    this.updateRemainingTime();
                }
            })
            });
        },
        /**查看题目答案详情 */
        viewAnswer() {
            this.dialogVisible = false;
            var dialog = this.$refs.answer_paper;
            if (dialog) {
                dialog.dialogVisible = true;
            }
        },
        /**提交试卷 */
        submitTestPaper(submitMode) {
            this.tTimer && clearInterval(this.tTimer);
            this.timer && clearInterval(this.timer);
            let userAnswerPOList = [];
            for (let key in this.detail.questionDetailVOS) {
                this.detail.questionDetailVOS[key] && this.detail.questionDetailVOS[key].forEach(item => {
                    var obj = {};
                    obj.questionId = item.questionId;
                    if (key == '多选题') {
                        obj.answer = item.value;
                    } else if (key == '填空题') {
                        var arr = [];
                        item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                            arr.push(el.value);
                        })
                        obj.answer = arr;
                    } else {
                        obj.answer = [item.value];
                    }
                    userAnswerPOList.push(obj);
                })
            }
            var params = {
                "businessId":this.paperId,
                "testPaperId": this.paperId,
                "userAnswerPOList": userAnswerPOList,
                "submitMode": submitMode,
                "testPaperRecordId":this.recordId,
                "testPaperSource":'test_paper_lib'
            }
            SubmitTestPaper(params).then(res => {
                if (res.code == 200) {
                    if (submitMode == 1) {
                        this.dialogVisible = true;
                    } else {
                        this.$msg({
                            showClose: true,
                            message: '暂存成功',
                            type: 'success'
                        });
                    }
                    this.getUserAnswerRecord();
                    this.isAnswer=false;
                    this.timer && clearInterval(this.timer);
                }
            })
        },
        /**获取试卷题目数据 */
        getTestPaperQuestion() {
            return new Promise(resolve => {
                var params={
                    "businessId":this.paperId,
                    "testPaperId":this.paperId,
                    "testPaperRecordId":this.recordId
                }
                GetTestPaperQuestion(params).then(res => {
                    if (res.code == 200) {
                        var questionDetailVOS = res.data.questionDetailVOS;
                        let arr=[];
                        var i = 1;
                        for (let key in questionDetailVOS) {
                            questionDetailVOS[key].orderIndex = i;
                            i++;
                            arr=[...arr,...questionDetailVOS[key]];
                            questionDetailVOS[key] && questionDetailVOS[key].forEach(item => {
                                if (key == '多选题') {
                                    item.value = [];
                                    return;
                                } else if (key == '填空题') {
                                    item.questionOptionVOS && item.questionOptionVOS.forEach(el => {
                                        el.value = '';
                                    })
                                } else {
                                    item.value = '';
                                }
                            })
                        }
                        this.subData=arr;
                        this.detail = res.data;
                        resolve(res.data);
                    }
                })
            })
        },
        /**更新状态 */
        updateStatus(){
            var params = {
                "businessId": this.paperId,
                "testPaperId": this.paperId,
                "testPaperSource": this.testPaperSource
            }
            GetUserAnswerRecord(params).then(async(res) => {
                if (res.code == 200) {
                    this.$set(this.detail,'viewCount',res.data.viewCount);
                    this.$set(this.detail,'likes',res.data.likes);
                    this.$set(this.detail,'collect',res.data.collect);
                    this.$set(this.detail,'collectCount',res.data.collectCount);
                    this.$set(this.detail,'likeCount',res.data.likeCount);
                }
            })
        },
        /**获取用户答题记录 */
        getUserAnswerRecord() {
            var params = {
                "businessId": this.paperId,
                "testPaperId": this.paperId,
                "testPaperSource": this.testPaperSource
            }
            GetUserAnswerRecord(params).then(async(res) => {
                if (res.code == 200) {
                    this.recordId=res.data.id;
                    await this.getTestPaperQuestion();
                    this.isFinish = Number(res.data.status);
                    this.remainingTime = res.data.remainingTime;
                    this.startTime=res.data.startTime;
                    this.countDown();
                    this.updateRemainingTime();
                    let questionDetailVOS = this.detail.questionDetailVOS;
                    this.$set(this.detail,'viewCount',res.data.viewCount);
                    this.$set(this.detail,'likes',res.data.likes);
                    this.$set(this.detail,'collect',res.data.collect);
                    this.$set(this.detail,'collectCount',res.data.collectCount);
                    this.$set(this.detail,'likeCount',res.data.likeCount);
                    this.$set(this.detail,'startTime',res.data.startTime);
                    this.$set(this.detail,'endTime',res.data.endTime);
                    res.data.userQuestionScoreVOS && res.data.userQuestionScoreVOS.forEach(item => {
                        var data = questionDetailVOS[item.questionType];
                        var userAnswer = item.userAnswer || [];
                        if (data) {
                            let e = data.find(el => el.questionId == item.questionId);
                            if (e) {
                                this.$set(e, 'correctAnswer', item.correctAnswer || []);
                                this.$set(e, 'score', item.score || 0);
                                this.$set(e, 'content', item.content || '暂无');
                                var questionType = item.questionType;
                                if (questionType == '多选题') {
                                    e.value = userAnswer;
                                } else if (questionType == '填空题') {
                                    e.questionOptionVOS.forEach((a, b) => {
                                        a.value = userAnswer[b] ? userAnswer[b] : '';
                                    })
                                } else {
                                    e.value = userAnswer[0] ? userAnswer[0] : '';
                                }
                            }
                        }
                    })
                }
            })
        }
    },
    mounted() {
        this.getUserAnswerRecord();
        this.addOptRecord(2);
    },
    destroyed(){
        this.timer&&clearInterval(this.timer);
        this.tTimer&&clearInterval(this.tTimer);
    }
}
</script>

<style lang="less" scoped>
.paper-box {
    padding: 15rem var(--padding) 3rem var(--padding);
    position: relative;
    .top-box {
        border: 1px solid #e2e4eb;
        margin-top: 3.2rem;
        padding: 4rem 2.5rem 2rem 2.5rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        position: relative;
        .top-img{
            position: absolute;
            right: 0;
            top: 0;
            width: 10.6rem;
            cursor: pointer;
        }
        .img-box-content{
            position: relative;
        .number{
            position: absolute;
            width: 6rem;
            text-align: center;
            top: 12px;
            left: 0rem;
            font-weight: 700;
            font-size: 1.8rem;
        }
        }
        .top-content{
            display: flex;
            .score-bg{
                width: 9rem;
            }
            .paper-ev{
                .paper-name{
                    font-weight: 700;
                    font-size: 2.4rem;
                    color: #000000;
                }
                .paper-base{
                    display: flex;
                    color: #8590B3;
                    .top-item{
                        display: flex;
                        margin-top: 0.2rem;
                    }
                }
            }
        }
        .bottom-content{
            display: flex;
            color: #8590B3;
            margin-top: 4rem;
            justify-content: space-between;
            .show-box-ev{
                display: flex;
                flex-wrap: wrap;
                gap: 1rem;
                .right-item{
                    display: flex;
                    &> :nth-child(2){
                        color: var(--blue);
                    }
                }
            }
        }
    }
}
.operation-box{
    display: flex;
    align-items: center;
}
.module-top {
    height: 6rem;
    background: #f7f9ff;
    border: 1px solid #e8ecef;
    color: #334681;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    padding: 0 2.5rem;
}

.module-content {
    padding: 0 6rem;
    color: #334681;
    border: 1px solid #e8ecef;

    .content-item {
        padding: 3.5rem 0;
        border-bottom: 1px solid #e8ecef;
    }
}

.border-none {
    border-bottom: none !important;
}

.el-top {
    display: flex;
}

.html-box {
    white-space: var(--lineWrap);
}

.options-box {
    margin-top: 1.5rem;
}

/deep/.el-radio-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-radio {
    margin-top: 2rem;
    display: flex;
}

/deep/.el-checkbox-group {
    display: flex;
    flex-direction: column;
}

/deep/.el-checkbox {
    margin-top: 2rem;
}

/deep/.el-input__inner {
    border: 1px solid transparent;
    border-bottom: 1px solid #334681;
    border-radius: 0;
}

.btn-box {
    display: flex;
    padding: 5rem 0;
    display: flex;
    justify-content: center;
}

.el-title {
    font-size: 2rem;
    color: #334681;
    font-weight: 700;
    text-align: center;
}

.el-view {
    color: #387DFF;
    text-align: center;
    margin-top: 2.5rem;
    margin-bottom: 5rem;
    cursor: pointer;
}

/deep/.el-dialog__header {
    display: flex;
    justify-content: center;
    font-weight: 700;
}

/deep/.el-dialog {
    border-radius: 1rem;
}

.answer-box {
    color: #334681;
    margin-top: 2rem;

    .box-item {
        display: flex;

        &> :nth-child(2) {
            color: var(--blue);
        }

        &> :nth-child(3) {
            margin-left: 1rem;
        }
    }
}

.an-item {
    display: flex;
    color: #334681;
    margin-top: 1rem;
}
.tip-box{
    .light{
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background-color: #FF2222;
        margin-right: 1rem;
    }   
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    height: 4rem;
    width: 25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #334681;
    position: fixed;
    top: 8.5rem;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
}
/deep/.el-input.is-disabled .el-input__inner{
    background-color: transparent;
    border-color: transparent;
    border-bottom: 1px solid #000000;
}
.icon-fanhui1{
    position: absolute;
    top: 15.2rem;
    left: 33rem;
    color: #000000;
    font-size: 2rem;
    cursor: pointer;
}
.dz{
    color: #FF4E00 !important;
}
.sc{
    color: rgb(247,186,42) !important;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
@media screen and (max-width:750px){
    .icon-fanhui1{
        left: 19rem;
    }
    .bottom-content{
        flex-direction: column;
    }
    .operation-box{
        &> :nth-child(1){
            margin-left: 0 !important;
        }
    }
}
</style>